/**
 * This logic matches the gutter logic that epubjs itself applies to the book.
 */
export const getGutterWidth = (bookWidth) => Math.max(64, Math.min(Math.floor(bookWidth / 8), 192)) / 2;
